// Default legal & support content (from the previously published pages). Editable from the admin dashboard.
import type { LegalContent } from "./siteContent";
export const defaultLegal: LegalContent = {
  "privacy": {
    "titleAr": "سياسة الخصوصية",
    "titleEn": "Privacy Policy",
    "updatedAr": "آخر تحديث: 11 سبتمبر 2026",
    "updatedEn": "Last updated: September 11, 2026",
    "introAr": "تحترم ميلنكس خصوصيتك. توضّح هذه السياسة البيانات التي نعالجها لتقديم تطبيق الاشتراكات والوجبات والتوصيل، وكيف نحميها وخياراتك بشأنها",
    "introEn": "Mealnex respects your privacy. This policy explains the data we process to provide subscriptions, meals, and delivery services, how we protect it, and the choices available to you",
    "sections": [
      {
        "id": "data",
        "titleAr": "البيانات التي نجمعها",
        "titleEn": "Information we collect",
        "bodyAr": "- بيانات الحساب: الاسم ورقم الجوال والبريد الإلكتروني عند توفيره\n- بيانات الخدمة: المطعم المختار، الاشتراكات، الوجبات، الطلبات وسجل الصرف\n- بيانات التوصيل: اسم العنوان والموقع الجغرافي أو رابطه والصورة التي ترفقها للموقع\n- بيانات الدفع: طريقة الدفع وصورة الإيصال عند اختيار التحويل. لا نخزن بيانات بطاقتك البنكية داخل ميلنكس\n- بيانات الجهاز: رمز الإشعارات ومعلومات تقنية لازمة للأمان وتشغيل التطبيق",
        "bodyEn": "- Account information: name, mobile number, and email address when provided\n- Service information: selected restaurant, subscriptions, meals, orders, and redemption history\n- Delivery information: address label, location or map link, and any location image you upload\n- Payment information: payment method and receipt image for transfers. Mealnex does not store your bank card details\n- Device information: push notification token and technical data required for security and app operation",
        "draft": false
      },
      {
        "id": "use",
        "titleAr": "كيف نستخدم البيانات",
        "titleEn": "How we use information",
        "bodyAr": "نستخدم البيانات لتسجيل الدخول، وربطك بالمطعم الذي اخترته، وإدارة اشتراكك وطلباتك وتوصيلك، والتحقق من المدفوعات، وإرسال التنبيهات، وتقديم الدعم، ومنع إساءة الاستخدام والوفاء بالمتطلبات النظامية",
        "bodyEn": "We use information to authenticate you, connect you with your selected restaurant, manage subscriptions, orders and delivery, verify payments, send notifications, provide support, prevent abuse, and meet legal requirements",
        "draft": false
      },
      {
        "id": "sharing",
        "titleAr": "المشاركة ومقدمو الخدمة",
        "titleEn": "Sharing and service providers",
        "bodyAr": "تظهر البيانات اللازمة للمطعم الذي اخترته لتنفيذ خدمتك. وقد نعتمد على Firebase وGoogle Cloud للمصادقة والاستضافة، وAuthentica لإرسال رمز التحقق، وApple لإرسال الإشعارات، وعلى بوابة الدفع التي تختارها عند تفعيلها. لا نبيع بياناتك ولا نستخدمها للإعلانات الموجهة أو التتبع عبر التطبيقات",
        "bodyEn": "Required information is shared with the restaurant you selected to fulfil your service. We may use Firebase and Google Cloud for authentication and hosting, Authentica for verification codes, Apple for notifications, and the payment provider you choose when enabled. We do not sell your data or use it for targeted advertising or cross-app tracking",
        "draft": false
      },
      {
        "id": "retention",
        "titleAr": "الاحتفاظ والحذف",
        "titleEn": "Retention and deletion",
        "bodyAr": "نحتفظ بالبيانات طوال الحاجة لتقديم الخدمة أو المدة التي يوجبها النظام. يمكنك حذف حسابك من: حسابي ← حذف الحساب. نحذف حساب الدخول وبيانات التواصل والموقع، ونفصلها عن السجلات التشغيلية. قد يحتفظ المطعم بسجلات الفواتير والمعاملات للمدة النظامية المطلوبة، مع تقييد الوصول وإخفاء بياناتك حيثما يسمح النظام",
        "bodyEn": "We retain information only as needed to provide the service or as required by law. You can delete your account from My Account → Delete Account. We delete your sign-in account, contact and location data and detach them from operational records. The restaurant may retain invoices and transaction records for legally required periods, with restricted access and anonymisation where permitted",
        "draft": false
      },
      {
        "id": "rights",
        "titleAr": "حقوقك والتواصل",
        "titleEn": "Your rights and contact",
        "bodyAr": "يمكنك تحديث عنوان التوصيل داخل التطبيق، أو طلب الوصول أو التصحيح أو الاعتراض أو المساعدة في الحذف عبر البريد التالي: support@mealnex.app",
        "bodyEn": "You can update your delivery address in the app, or request access, correction, objection, or deletion assistance at: support@mealnex.app",
        "draft": false
      }
    ]
  },
  "terms": {
    "titleAr": "شروط الاستخدام",
    "titleEn": "Terms of Use",
    "updatedAr": "آخر تحديث: 11 سبتمبر 2026",
    "updatedEn": "Last updated: September 11, 2026",
    "introAr": "باستخدام ميلنكس فإنك توافق على هذه الشروط. التطبيق منصة تقنية تربطك بالمطعم الصحي الذي تختاره لإدارة الاشتراك والوجبات والتوصيل",
    "introEn": "By using Mealnex, you agree to these terms. The app is a technology platform connecting you with the healthy restaurant you choose for subscriptions, meals, and delivery",
    "sections": [
      {
        "id": "account",
        "titleAr": "الحساب والاستخدام",
        "titleEn": "Account and acceptable use",
        "bodyAr": "يجب تقديم معلومات صحيحة والمحافظة على سرية رمز التحقق وعدم إساءة استخدام التطبيق أو محاولة الوصول إلى حسابات أو أنظمة أخرى. أنت مسؤول عن النشاط الذي يتم عبر رقم جوالك",
        "bodyEn": "You must provide accurate information, keep verification codes confidential, and not misuse the app or attempt to access other accounts or systems. You are responsible for activity performed through your mobile number",
        "draft": false
      },
      {
        "id": "subscriptions",
        "titleAr": "الاشتراكات والطلبات",
        "titleEn": "Subscriptions and orders",
        "bodyAr": "يعرض كل مطعم باقاته ومنيوه وأسعاره وسياسات التجهيز والتوصيل والإلغاء. تنفيذ الوجبات وجودتها وتوفرها والتوصيل مسؤولية المطعم المتعاقد مع العميل، وتساعد ميلنكس في إدارة العملية وعرض حالتها",
        "bodyEn": "Each restaurant sets its plans, menu, prices, preparation, delivery, and cancellation policies. Meal fulfilment, quality, availability, and delivery are the responsibility of the restaurant contracting with the customer; Mealnex helps manage and display the process",
        "draft": false
      },
      {
        "id": "payments",
        "titleAr": "الدفع والاسترداد",
        "titleEn": "Payments and refunds",
        "bodyAr": "المدفوعات تخص وجبات أو خدمات فعلية خارج التطبيق. تظهر طريقة الدفع والرسوم قبل تأكيد الطلب. تخضع طلبات الإلغاء والاسترداد لسياسة المطعم والأنظمة المعمول بها",
        "bodyEn": "Payments cover physical meals or services consumed outside the app. Payment methods and charges are shown before confirmation. Cancellations and refunds are subject to the restaurant policy and applicable law",
        "draft": false
      },
      {
        "id": "availability",
        "titleAr": "التوفر والتغييرات",
        "titleEn": "Availability and changes",
        "bodyAr": "قد تتوقف بعض الخصائص مؤقتاً للصيانة أو لأسباب خارجة عن السيطرة. قد نحدّث هذه الشروط عند تطوير الخدمة، ويظهر تاريخ آخر تحديث أعلى الصفحة",
        "bodyEn": "Some features may be temporarily unavailable for maintenance or circumstances beyond our control. We may update these terms as the service evolves; the latest revision date appears above",
        "draft": false
      },
      {
        "id": "restaurants",
        "titleAr": "اشتراك المطاعم في ميلنكس",
        "titleEn": "Restaurant subscriptions to Mealnex",
        "bodyAr": "يتاح ميلنكس للمطاعم باشتراك شهري قدره 399 ريالًا لكل فرع، ورسوم تأسيس لمرة واحدة قدرها 1,875 ريالًا. تُوضّح الضرائب إن وجدت، والخدمات الخارجية ذات التكلفة المستقلة، في العرض النهائي وشروط الاشتراك\n\nيتحمل المطعم مسؤولية صحة بيانات باقاته وأسعاره وسياساته المعروضة لعملائه، واختيار الأدوار والصلاحيات المناسبة لموظفيه. وتُحدَّد شروط الفوترة والتجديد وإنهاء اشتراك المطعم في العرض النهائي أو الاتفاقية الموقعة",
        "bodyEn": "Mealnex is offered to restaurants for SAR 399 per branch per month, plus a one-time setup fee of SAR 1,875. Any taxes and separately priced third-party services are stated in the final offer and subscription terms\n\nThe restaurant is responsible for the accuracy of the plans, prices, and policies it shows its customers, and for assigning appropriate roles and permissions to its staff. Billing, renewal, and termination terms for the restaurant are set out in the final offer or signed agreement",
        "draft": true
      },
      {
        "id": "law",
        "titleAr": "القانون والتواصل",
        "titleEn": "Law and contact",
        "bodyAr": "تخضع هذه الشروط للأنظمة المعمول بها في المملكة العربية السعودية. للاستفسارات تواصل معنا عبر: support@mealnex.app",
        "bodyEn": "These terms are governed by the laws of the Kingdom of Saudi Arabia. For questions, contact: support@mealnex.app",
        "draft": false
      }
    ]
  },
  "support": {
    "titleAr": "دعم ميلنكس",
    "titleEn": "Mealnex Support",
    "updatedAr": "نحن هنا لمساعدتك",
    "updatedEn": "We are here to help",
    "introAr": "إذا واجهتك مشكلة في الدخول أو الاشتراك أو الطلب أو الإشعارات، أرسل لنا وصفاً مختصراً مع اسم المطعم ورقم جوالك، دون إرسال رمز التحقق",
    "introEn": "If you have an issue with sign-in, subscriptions, orders, or notifications, email us a short description with the restaurant name and your mobile number. Never send your verification code",
    "mailLabelAr": "مراسلة الدعم",
    "mailLabelEn": "Email support",
    "quick": [
      {
        "qAr": "لم يصل رمز التحقق؟",
        "qEn": "Did not receive the verification code?",
        "aAr": "تأكد من الرقم السعودي وانتظر دقيقة قبل إعادة الإرسال، ثم تحقق من تغطية الشبكة",
        "aEn": "Check the Saudi mobile number, wait one minute before resending, and confirm network coverage"
      },
      {
        "qAr": "كيف أغيّر عنوان التوصيل؟",
        "qEn": "How do I change my delivery address?",
        "aAr": "من تبويب حسابي اختر موقع التوصيل، أو افتح بطاقة اشتراك التوصيل واضغط تغيير",
        "aEn": "From My Account, select Delivery Location, or open your delivery subscription card and tap Change"
      },
      {
        "qAr": "كيف أحذف حسابي؟",
        "qEn": "How do I delete my account?",
        "aAr": "من تبويب حسابي اختر حذف الحساب، اقرأ الأثر، واكتب كلمة حذف للتأكيد",
        "aEn": "From My Account, select Delete Account, review the impact, and type Delete to confirm"
      },
      {
        "qAr": "سياسة الخصوصية",
        "qEn": "Privacy Policy",
        "aAr": "شروط الاستخدام",
        "aEn": "Terms of Use"
      }
    ]
  }
};
